export {ModalLoader} from './ModalLoader';

export type {ModalLoaderProps} from './ModalLoader.type';
